import {
  Link,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { cvDownloadAdres, useCvMutaties, useCvWachtrij } from '../../api/cvs.ts';
import type { CvVerwerkingsstatus } from '../../api/typen.ts';
import { Laadstatus } from '../../componenten/Laadstatus.tsx';
import { useMeldingen } from '../../componenten/Meldingen.tsx';
import { Pagina } from '../../componenten/Pagina.tsx';
import { Lijstpaginering } from '../../componenten/Paginering.tsx';
import { KandidaatVerwijzing } from '../../componenten/Verwijzingen.tsx';
import { bestandsgrootte, datumTijd } from '../../helpers/formatteer.ts';
import { cvVerwerkingsstatusLabels, opties } from '../../helpers/labels.ts';
import { useZoekparameters } from '../../hooks/useZoekparameters.ts';

const statusOpties = opties(cvVerwerkingsstatusLabels);

/**
 * De cv's die wachten op verwerking, oudste eerst. Hier zet je de verwerkingsstatus handmatig, zolang er geen
 * automatische cv-verwerking is.
 * @returns De pagina.
 */
export function CvWachtrijPagina() {
  const { offset, limiet, zetOffset } = useZoekparameters(25);
  const wachtrij = useCvWachtrij({ limiet, offset });
  const mutaties = useCvMutaties();
  const { meld, meldFout } = useMeldingen();

  return (
    <Pagina titel="Cv-wachtrij" ondertitel="Cv's die nog verwerkt moeten worden, oudste eerst.">
      <Paper sx={{ p: 2 }}>
        <Laadstatus query={wachtrij} leeg="De wachtrij is leeg.">
          {(cvs) => (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Bestand</TableCell>
                    <TableCell>Kandidaat</TableCell>
                    <TableCell>Geüpload</TableCell>
                    <TableCell>Grootte</TableCell>
                    <TableCell>Verwerking</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cvs.map((cv) => (
                    <TableRow key={cv.id} hover>
                      <TableCell>
                        <Link href={cvDownloadAdres(cv.id)} underline="hover" sx={{ fontWeight: 500 }}>
                          {cv.bestandsnaam}
                        </Link>
                      </TableCell>
                      <TableCell>
                        <KandidaatVerwijzing id={cv.kandidaatId} />
                      </TableCell>
                      <TableCell>{datumTijd(cv.geuploadOp)}</TableCell>
                      <TableCell>{bestandsgrootte(cv.grootteBytes)}</TableCell>
                      <TableCell>
                        <Select
                          size="small"
                          value={cv.verwerkingsstatus}
                          onChange={(gebeurtenis) =>
                            mutaties.zetVerwerkingsstatus
                              .mutateAsync({
                                id: cv.id,
                                kandidaatId: cv.kandidaatId,
                                status: gebeurtenis.target.value as CvVerwerkingsstatus,
                              })
                              .then(() => meld('Verwerkingsstatus gewijzigd'))
                              .catch(meldFout)
                          }
                          sx={{ minWidth: 160 }}
                        >
                          {statusOpties.map((optie) => (
                            <MenuItem key={optie.waarde} value={optie.waarde}>
                              {optie.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Laadstatus>
        <Lijstpaginering offset={offset} limiet={limiet} aantal={wachtrij.data?.length ?? 0} onOffset={zetOffset} />
      </Paper>
    </Pagina>
  );
}
